import script from "./TicketSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketSummary.vue?vue&type=script&lang=ts&setup=true"

import "./TicketSummary.vue?vue&type=style&index=0&id=c6c60c3a&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6c60c3a"]])

export default __exports__